module.exports = __webpack_public_path__ + "media/images/how-to-apply-da63b917b6d533a73a1d350b28bde581.png";